export enum QuestroomCancelationTypeEnum {
    NO = 'no',
    FIXED = 'fixed',
    MIN_PRICE = 'min_price',
    HALF_PRICE = 'half_price',
    FULL_PRICE = 'full_price',
}
